import { useNavigation } from "@react-navigation/native";
import React, { useEffect } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
} from "react-native";
import { Color, globalFontStyle } from "../../../assets";
import FastImage from "../../../common/FastImage";
import CustomButton from "../../../commonComponents/CustomButton";
import { order_fail } from "../../../utils/images";
import {globalImport} from "../../../common/globalImports";

const InsufficientFundBlk = (props) => {
  const navigation = useNavigation();
  const addFunds = () => {
    var insufficientFund = parseInt(props?.amount) - parseInt(props?.balance);
    props.onBottomSheetClose();
    navigation.push("WalletStack", {
      screen: "WalletAdd",
      params: { rechargeAmount: insufficientFund.toString() },
    });
  };
  return (
    <View style={styles.insufficientBlk}>
      <View style={{ flexDirection: "row" }}>
        <FastImage
          style={styles.backBtnStyle}
          source={order_fail()}
        />
        <View style={{ marginLeft: 10 }}>
          <Text
            style={[
              globalFontStyle.appFontSmallTextBold,
              { color: Color.black },
            ]}
          >
            Insufficient Funds
          </Text>
          <Text style={globalFontStyle.appFontSmallText}>
            Please add funds to your wallet
          </Text>
        </View>
      </View>

      <CustomButton
        btnText="Add Funds"
        btnType={"normalBlue"}
        onBtnClick={addFunds}
        customStyle={{ flex: globalImport.isWeb ? {} : 0, paddingVertical: 15, paddingHorizontal: 20 }}
      />
    </View>
  );
};

export default InsufficientFundBlk;

const styles = StyleSheet.create({
  backBtnStyle: {
    width: 30,
    height: 30,
  },
  insufficientBlk: {
    paddingVertical: 11,
    paddingHorizontal: 12,
    marginTop: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "rgba(233, 0, 0, 0.05)",
    marginLeft: -13,
    marginRight: -13,
    alignItems: "center",
    marginBottom: -16,
  },
});
